const CART_POPUP_DEBUG = false;
// init
function initAddToCartPopup(addToCartBtn, qtyBtn, popupContainer, closeBtn, firstInit) {
    firstInit && initCartBtn(addToCartBtn);
    firstInit && initQuantityBtn(qtyBtn);
    initVariantBoxes(popupContainer, ".strength-box:not('.unavailable')");
    initCartPopupEvents(closeBtn);
}
window.initAddToCartPopup = initAddToCartPopup;

function initCartPopupEvents(elements) {
    $(elements).on("click", function (e) {
        $(e.target).parents("[data-add-to-cart-popup], [data-add-to-cart-popup-2]").hide();
    })
}

//buttons

function initCartBtn(selector) {
    $(selector).off("click", addToCartBtnEvent);
    $(selector).on("click", addToCartBtnEvent);
    $(selector).text(shopifyData.addToCartText);
}

function addToCartBtnEvent(e) {
    addToCart(e.target);
    getCart($(e.target).parents("[data-add-to-cart-popup]").siblings("[data-add-to-cart-popup-2]"));
    return false;
}

//Variants

function initVariantBoxes(popup, selector) {
    $(popup).find('[data-add-to-cart]').addClass('disabled');

    $(popup).find(selector).on("click", (e) => {
        $(e.target).siblings().removeClass("selected");
        $(e.target).siblings().removeAttr("data-selected-variant");

        $(e.target).addClass("selected");
        $(e.target).attr("data-selected-variant", true);
        $(popup).find('[data-add-to-cart]').removeClass('disabled');
    });

    $(popup).find('[data-add-to-cart]').attr("data-product-id", $(popup).find('data-selected-variant').attr('data-variant-id'));
}


//Quantity
function initQuantityBtn(button) {
    if ($(button)) {
        $(button).find("[data-qty]").val('1');

        $(button).find("[data-qty-dec]").off("click", changeQtyEventDec); //dec
        $(button).find("[data-qty-dec]").on("click", changeQtyEventDec); //dec
        $(button).find("[data-qty-inc]").off("click", changeQtyEventInc); //inc
        $(button).find("[data-qty-inc]").on("click", changeQtyEventInc); //inc

        checkQty(button, "[data-qty-dec]");
    }
}

function changeQtyEventDec(e) {
    changeQty(e, -1);
}

function changeQtyEventInc(e) {
    changeQty(e, 1);
}

function checkQty(parentBtn, parentBtnQty) {
    if ($(parentBtnQty).val() >= 2) {
        $(parentBtn).find("[data-qty-inc]").removeClass("unavailable");
        $(parentBtn).find("[data-qty-dec]").removeClass("unavailable");
    } else if ($(parentBtnQty).val() <= 1) {
        $(parentBtn).find("[data-qty-dec]").addClass("unavailable");
    }
    //check if cart is available
}

function changeQty(e, increment) {
    console.log("changeQty", increment);
    const parentBtn = $(e.target).parents("[data-qty-btn]");
    const parentBtnQty = parentBtn.find("[data-qty]");

    parentBtnQty.attr('value', parseInt(parentBtnQty.val()) + increment);
    parentBtnQty.val(parseInt(parentBtnQty.val()) + increment);
    checkQty(parentBtn, parentBtnQty);
}

//Add to Cart
function addToCart(elem) {
    const $variantId = $(elem).parents("[data-add-to-cart-popup]").find("[data-selected-variant]");
    // const productId = $(elem).parents("[data-add-to-cart-popup]").attr("data-product-id"); // for sendTrackingEventsATC();
    // const productName = $(elem).parents("[data-add-to-cart-popup]").attr("data-product-name"); //for sendTrackingEventsATC();
    const variantId = $($variantId).attr("data-variant-id");

    const $quantity = $(elem).parents("[data-add-to-cart-popup]").find("[data-qty]");
    const quantity = $quantity.val();

    CART_POPUP_DEBUG && console.warn(variantId, quantity);
    $(elem).addClass("btn-loading");


    //add to cart
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            items: [{
                id: variantId,
                quantity: quantity
            }]
        },
        success: function () {
            $(elem).parents("[data-add-to-cart-popup]").siblings("[data-add-to-cart-popup-2]").show();
            $(elem).parents("[data-add-to-cart-popup]").find("[data-error-text]").hide();

            // no more tracking events for Add to cart, since they already have
            // enable below if needed
            // sendTrackingEventsATC();
            return;
        },
        error: function (error) {
            console.warn(error);
            $(elem).parents("[data-add-to-cart-popup]").show();
            $(elem).parents("[data-add-to-cart-popup]").find("[data-error-text]").show();
            $(elem).parents("[data-add-to-cart-popup]").find("[data-error-text]").text(error.responseJSON.message + ": " + error.responseJSON.description);
            CART_POPUP_DEBUG && console.error("POST Error:", error);
            return;
        },
        complete: function () {
            $(elem).removeClass("btn-loading");
        }
    });
}

// no more tracking events for Add to cart, since they already have
// enable below if needed
// function sendTrackingEventsATC(){

//     //google analytics
//     ga('send', {
//         hitType: 'event',
//         eventCategory: 'Engagement',
//         eventAction: 'Try on',
//         eventLabel: 'Test'
//     });


//     //facebook tracking client side facebook pixel
//     fbq(
//         'trackCustom', 'Try on', {
//         content_name: productName,
//         content_ids: [productId],
//         content_type: 'product',
//         currency: theme.settings.currency
//     }
//     );

//     //facebook tracking server side conversions api

//     let fbTrackingUrl = `https://netlify.blacklemon.dk/.netlify/functions/facebookTracking?storeCurrency=${theme.settings.currency}&prodVal=${0}&prodQuant=${quantity}&prodId=${productId}&eventType=buying`;

//     $.ajax({
//         url: fbTrackingUrl,
//         type: "GET",
//         crossDomain: true,
//         success: function (response) {
//             console.log('success: ', response);
//         },
//         error: function (xhr, status) {
//             console.log('error ', xhr, status);
//         }
//     });

// }


//Fetch cart
function getCart(popup) {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        async: false,
        cache: false,
        dataType: 'json',
        success: function (cart) {
            updateDiscountText(cart, popup);
        },
        error: function (error) {
            CART_POPUP_DEBUG && console.error("GET Error:", error);
        }
    });
}

function updateDiscountText(cart, popup) {
    CART_POPUP_DEBUG && console.warn(popup);
    let diffToDiscount = 3 - parseInt(cart.item_count) - 1;
    if (diffToDiscount <= 0) diffToDiscount = 0;
    if (diffToDiscount >= 3) diffToDiscount = 3;

    CART_POPUP_DEBUG && console.warn(cart.item_count);

    $(popup).find(`[data-glasses-${diffToDiscount}-left]`).addClass("unchecked");
    $(popup).find(`[data-glasses-${diffToDiscount + 1}-left]`).addClass("unchecked");
    $(popup).find(`[data-glasses-${diffToDiscount + 2}-left]`).addClass("unchecked");


    switch (true) {
        case (diffToDiscount == 0):
            $(popup).find(`[data-glasses-${diffToDiscount}-left]`).removeClass("unchecked");
            $(popup).find(`[data-glasses-${diffToDiscount + 1}-left]`).removeClass("unchecked");
            $(popup).find(`[data-glasses-${diffToDiscount + 2}-left]`).removeClass("unchecked");
            break;
        case (diffToDiscount == 1):
            $(popup).find(`[data-glasses-${diffToDiscount}-left]`).removeClass("unchecked");
            $(popup).find(`[data-glasses-${diffToDiscount + 1}-left]`).removeClass("unchecked");
            break;
        case (diffToDiscount == 2):
            $(popup).find(`[data-glasses-${diffToDiscount}-left]`).removeClass("unchecked");
            break;
    }

    $(popup).find('[data-glasses-to-go]').text(diffToDiscount);

    if (diffToDiscount <= 0) {
        $(popup).find("[data-success-text]").show();
        $(popup).find("[data-success-hide]").hide();
    }

    $(popup).hide();
    $(popup).siblings("[data-add-to-cart-popup]").hide();
}